import { AuthMethod } from "../bankid/types";
export class CreditAssessmentSignResponse {
    constructor(response, request) {
        if (!response) {
            throw new Error("Response can not be falsy");
        }
        if (!request.method) {
            throw new Error("Method can not be falsy");
        }
        this.qrCodeAsBase64 = response.qrCodeAsBase64;
        this.autoLaunchUrl = response.autoLaunchUrl;
        this.method = request.method;
        this.caseId = request.caseId;
    }
    getMethod() {
        return this.method;
    }
    isQrCode() {
        return this.method === AuthMethod.QrCode;
    }
    isSameDevice() {
        return this.method === AuthMethod.SameDevice;
    }
    getQrCode() {
        if (!this.isQrCode()) {
            throw new Error("Not qr code response");
        }
        return this.qrCodeAsBase64;
    }
    getAutoLaunchUrl() {
        if (!this.isSameDevice()) {
            throw new Error("Not same device response");
        }
        return this.autoLaunchUrl;
    }
    getCaseId() {
        return this.caseId;
    }
}
